import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'
import AddCallDest from "../../dialogs/addCallDest"

import '../../index.css';

function normalizeDestination(msgObj) {
  let dest = msgObj?.destination;

  // if it's a JSON string like "[]", parse it
  if (typeof dest === "string") {
    try {
      dest = JSON.parse(dest);
    } catch {
      dest = [];
    }
  }

  // ensure it's an array
  if (!Array.isArray(dest)) dest = [];

  return { ...msgObj, destination: dest };
}

const DestinationList = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [destinationListState, setdestinationListState] = useState({ "destination": [] });
    const [openAddCallDest, setOpenAddCallDest] = useState(false);
    const handleCloseAddCallDest = () => {
      setOpenAddCallDest(false)
    };
    const handleOpenAddCallDest = () => {
      setOpenAddCallDest(true)
    };

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setdestinationListState(normalizeDestination(data))
    }, [data]);

    function refreshdestinationList() {
        mqttReq(serial, '/destinationmqttreq')
    }

    const handleDeleteDestination = (id) => {
      updateTable({serial, object: "destination", action: "delete", id}, '/destinationmqttset', () => {})
    };

    const handleCreateDestination = (type, dest) => {
      updateTable({serial, object: "destination", action: "add", type, dest}, '/destinationmqttset', () => {})
    };

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <AddCallDest isOpen={ openAddCallDest } onClose = { handleCloseAddCallDest } addCallDest = {handleCreateDestination} />
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'blue', color: 'white', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi Destinatari' : 'Mostra Destinatari'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_device" colSpan="2">Destinatari Chiamata</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                                {destinationListState?.time}
                            </th>
                        </tr>
                        <tr>
                            <th className="title">type</th>
                            <th className="title">destinatario</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={refreshdestinationList}>aggiorna</button>
                                <button onClick={handleOpenAddCallDest} style={{ marginLeft: "8px" }}>aggiungi</button>
                            </th>
                        </tr>
                        {destinationListState?.destination.map(mapDest => (
                            <tr key={mapDest.id}>
                                <td>{mapDest.type}</td>
                                <td>{mapDest.dest}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                  {/* Delete button */}
                                  <button
                                    onClick={() => {handleDeleteDestination(mapDest.id); refreshdestinationList();}}
                                  >
                                    elimina
                                  </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default DestinationList;
